export default "__VITE_ASSET__c3a254cd__$_?component__"